import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { DrsTypeOffice } from 'Pages/registratorCabinet'
import { RequestParams, ResponseCatalog } from 'Models'
import { GetItemsPayload } from 'Types/getItemsPayload'
import { SberGeoUnitModel } from 'Pages/orders_design'

export type DrsState = {
	office: DrsTypeOffice | null
	requestParams: RequestParams
	units: ResponseCatalog<SberGeoUnitModel>
}

export const drsInitialState: DrsState = {
	office: null,
	requestParams: new RequestParams(),
	units: new ResponseCatalog<SberGeoUnitModel>(),
}

export namespace DrsNS {
	export type GetDrsOffice = PayloadAction<{ address: any }>
	export type SetDrsOffice = PayloadAction<DrsTypeOffice>
	export type setRequestParams = PayloadAction<RequestParams>
	export type getUnits = PayloadAction<GetItemsPayload>
	export type setUnits = PayloadAction<ResponseCatalog<SberGeoUnitModel>>
}

export const drsSlice = createSlice({
	name: 'drs',
	initialState: drsInitialState,
	reducers: {
		getOne: (state, action: DrsNS.GetDrsOffice) => {},
		setOne: (state, action: DrsNS.SetDrsOffice) => {
			state.office = action.payload
		},
		setRequestParams: (state, action: DrsNS.setRequestParams) => {
			state.requestParams = action.payload
		},
		getAllUnits: (state, action: DrsNS.getUnits) => {},
		clearAllUnit: (state) => {
			state.units = new ResponseCatalog<SberGeoUnitModel>()
			state.requestParams = new RequestParams()
		},
		setAllUnits: (state, action: DrsNS.setUnits) => {
			state.units = action.payload
		},
	},
})
